// The one table of supported UI locales, pure. Each entry carries the
// language's ENDONYM: its name written in itself ("English", "Svenska"),
// never translated, so every language picker stays readable to someone who
// can't read the current UI language (D13).
//
// Everything locale-shaped derives from this table: the `Locale` union, the
// `isLocale` boundary guard, the ordered `locales` list the pickers render,
// and (in setup.ts) the catalog map, typed `Record<Locale, Messages>` so a
// new entry here doesn't compile until its catalog is loaded.

export type { Locale };
export { endonym, isLocale, locales };

const table = {
    en: { endonym: "English" },
    sv: { endonym: "Svenska" },
};

type Locale = keyof typeof table;

const isLocale = (v: unknown): v is Locale =>
    typeof v === "string" && Object.hasOwn(table, v);

// Table order = picker order.
const locales: readonly Locale[] = Object.keys(table).filter(isLocale);

const endonym = (l: Locale): string => table[l].endonym;
